import { createFileRoute } from '@tanstack/react-router';

import { OperationBillsOfOperations } from '../../features/operations/operation-bills-of-operations';
import { OperationDetailShell } from '../../features/operations/operation-detail-shell';
import { OperationRulesList } from '../../features/operations/operation-rules-list';
import { operationDetailQueryOptions } from '../../features/operations/queries';

export const Route = createFileRoute('/operations/$operation_id_/bill_of_operations')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { operation_id: operationId } = match.params as { operation_id: string };
      const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
      return data ? `${data.operation_name} — Bill of Operations` : 'Operation Bill of Operations';
    },
    layout: 'full-height',
  },
  component: OperationBillOfOperationsPage,
});

function OperationBillOfOperationsPage() {
  const { operation_id: operationId } = Route.useParams();

  return (
    <OperationDetailShell operationId={operationId} active="bill_of_operations">
      {(_operation, partnerId) => (
        <div className="flex flex-col gap-8 p-6">
          <section>
            <h3 className="mb-2 text-lg font-medium">Rules</h3>
            <p className="text-muted-foreground mb-3 text-sm">
              Relevance rules currently affecting which products this operation applies to. Adding
              or removing a rule cascades to a new Bill of Operations version on Release.
            </p>
            <OperationRulesList operationId={operationId} partnerId={partnerId} />
          </section>

          <section>
            <h3 className="mb-2 text-lg font-medium">Used by these Bills of Operations</h3>
            <p className="text-muted-foreground mb-3 text-sm">
              Edits to this operation cascade to a new version of each Bill of Operations listed
              below. To roll the new version onto work orders, open the Bill of Operations matrix
              and click Release on the affected products.
            </p>
            <OperationBillsOfOperations operationId={operationId} />
          </section>
        </div>
      )}
    </OperationDetailShell>
  );
}
